export default function Partnerhover() {
  Alpine.data("partnerhover", () => ({
    activeImage: null,
    visible: false,
    _mouseX: 0,
    _mouseY: 0,
    _lerpX: 0,
    _lerpY: 0,
    _raf: null,
    _imgEl: null,

    init() {
      this._imgEl = this.$el.querySelector("[data-partner-image]");

      const tick = () => {
        const dx = this._mouseX - this._lerpX;
        const dy = this._mouseY - this._lerpY;
        this._lerpX += dx * 0.2;
        this._lerpY += dy * 0.2;
        if (this._imgEl) {
          this._imgEl.style.transform = `translate(calc(${this._lerpX}px + 10%), calc(${this._lerpY}px + 10%))`;
        }
        this._raf =
          Math.abs(dx) > 0.1 || Math.abs(dy) > 0.1
            ? requestAnimationFrame(tick)
            : null;
      };

      const onMove = (e) => {
        this._mouseX = e.clientX;
        this._mouseY = e.clientY;
        if (!this._raf) this._raf = requestAnimationFrame(tick);
      };

      window.addEventListener("mousemove", onMove);

      const onScroll = () => {
        const el = document.elementFromPoint(this._mouseX, this._mouseY);
        const row = el?.closest("[data-partner-img]");
        if (row) {
          this.setImage(row.dataset.partnerImg);
        } else {
          this.clearImage();
        }
      };

      window.addEventListener("scroll", onScroll, { passive: true });

      this.$cleanup(() => {
        window.removeEventListener("mousemove", onMove);
        window.removeEventListener("scroll", onScroll);
        cancelAnimationFrame(this._raf);
      });
    },

    setImage(url) {
      if (!url) return;
      this.activeImage = url;
      this.visible = true;
    },

    clearImage() {
      this.visible = false;
    },
  }));
}
